import { Divider, Menu } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { forwardRef } from 'react';
import { listCountries } from "../country-code-metadata/CountryCodeMetadata.js";
import { PhoneFieldMenuItem } from "./PhoneFieldMenuItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  paper: {
    maxHeight: theme.spacing(30)
  }
}), {
  name: 'SD-PhoneFieldMenu'
});
export var PhoneFieldMenu = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    anchorEl,
    value,
    onClose,
    onChange
  } = _ref;
  var styles = useStyles();
  return /*#__PURE__*/_jsx(Menu, {
    ref: ref,
    open: !!anchorEl,
    onClose: onClose,
    anchorEl: anchorEl,
    classes: {
      paper: styles.paper
    },
    children: listCountries().map(country => [/*#__PURE__*/_jsx(PhoneFieldMenuItem, {
      country: country,
      selected: country === value,
      onClick: () => {
        onChange(country);
        onClose();
      }
    }, country), country === 'NZ' && /*#__PURE__*/_jsx(Divider, {}, "divider")])
  });
});
if (process.env.NODE_ENV !== "production") PhoneFieldMenu.displayName = "PhoneFieldMenu";